import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { Formik, Form, Field, ErrorMessage } from "formik";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import * as Yup from 'yup';
import { useGetCustomerByIdQuery, useSaveCustomerMutation, useGetGroupsQuery, useGetCustomerByGroupIdQuery } from "../../../../services/redux/api/components";
import { toast } from "react-toastify";

const AddCustomerMaster = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const passedGroupCode = location?.state?.groupCode || '';
  const passedGroupName = location?.state?.groupName || '';
  const passedGroupId = location?.state?.groupId || '';
  const isEditMode = Boolean(id);

  console.log('Debug - passedGroupId:', passedGroupId);
  console.log('Debug - location.state:', location?.state);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [groupIdForFetch, setGroupIdForFetch] = useState(passedGroupId || '');
  const [saveCustomer] = useSaveCustomerMutation();
  const { data: customerData, isLoading } = useGetCustomerByIdQuery(id, { skip: !isEditMode });
  const { data: groupsData, isLoading: isGroupsLoading } = useGetGroupsQuery({ pageNumber: 1, pageSize: 1000 });
  const { data: customersByGroup, isLoading: isGroupCustomersLoading } = useGetCustomerByGroupIdQuery(groupIdForFetch, { skip: !groupIdForFetch });
  console.log("groupsData", groupsData)
  // Show loading while fetching customer data
  if (isLoading) {
    return <div>Loading...</div>;
  }
  const fullName = customerData?.data?.FullName || '';  // Get the full name

  // Split full name by spaces
  const nameParts = fullName.trim().split(/\s+/);
  const initialValues = {
    customerType: customerData?.data?.CustomerType || 'Individual',
    initial: customerData?.data?.Initial || '',
    firstName: nameParts[0] || '',
    middleName: nameParts.length === 3 ? nameParts[1] : '',  // If there are 3 parts, set the middle name
    lastName: nameParts.length >= 2 ? nameParts[nameParts.length - 1] : '',
    shortName: customerData?.data?.ShortName || '',
    gender: customerData?.data?.Gender,
    dob: customerData?.data?.DOB ? customerData.data?.DOB.slice(0, 10) : '',
    groupCode: '',
    groupHead: customerData?.data?.Is_Group_Head ? "true" : "false",
    marriageDate: customerData?.data?.MarriageDate
      ? customerData.data?.MarriageDate.slice(0, 10)
      : '',
    isDead: customerData?.data?.IsDead ? "true" : "false",
    demiseDate: customerData?.data?.DemiseDate
      ? customerData.data?.DemiseDate.slice(0, 10)
      : '',
    mobile: customerData?.data?.Mobile || '',
    email: customerData?.data?.Email || '',
    pan: customerData?.data?.PAN || '',
    aadhar: customerData?.data?.Aadhar || '',
    address1: customerData?.data?.Address_1 || '',
    address2: customerData?.data?.Address_2 || '',
    address3: customerData?.data?.Address_3 || '',
    pinCode: customerData?.data?.PinCode || '',
    city: customerData?.data?.City || '',
    state: customerData?.data?.State || '',
    GroupID: customerData?.data?.GroupID || '',
    // GroupID: customerData?.data?.GroupID || (passedGroupId && passedGroupId !== 'undefined' ? passedGroupId : ''),
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    dob: Yup.string().required("Dob is required"),
    gender: Yup.string().required("Gender is required"),
    address1: Yup.string().required("Address 1 is required"),
    aadhar: Yup.string().matches(/^[0-9]{12}$/, 'Aadhar must be 12 digits').required('Aadhar is required'),
    GroupID: Yup.string().required("Group Code is required"),
  });

  const handleSubmit = (values) => {
    const resolvedGroupId = (values.GroupID && values.GroupID !== "undefined")
      ? values.GroupID
      : (passedGroupId || customerData?.data?.GroupID || "");

    if (!resolvedGroupId) {
      toast.error("Please select a Group before saving.");
      return;
    }

    const payload = {
      ...values,
      Mode: isEditMode ? "Update" : "Add",
      fullName: `${values.firstName} ${values.middleName} ${values.lastName}`.trim(),
      GroupID: resolvedGroupId,
    }
    if (isEditMode) {
      payload.customerId = id;
    }
    console.log("hyyy", payload);
  saveCustomer(payload)
    .then((response) => {
      console.log("API Response:", response);

      const data = response?.data;

      // ✅ Success condition: CustomerID exists or Message indicates success
      if (data?.CustomerID || data?.Message?.toLowerCase().includes("success")) {
        toast.success(data?.Message || (isEditMode ? "Customer updated successfully!" : "Customer added successfully!"));
        window.history.back();
      } else {
        toast.error(data?.Message || "Failed to save customer. Please try again.");
      }
    })
    .catch((error) => {
      console.error("Error during API call:", error);
      toast.error("An error occurred while saving the customer. Please try again.");
    });

  };

  // Utility function to allow only numbers
  const allowOnlyNumbers = (e) => {
    const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
      e.preventDefault();
    }
  };

  // const handleSubmit = (values) => {
  //   console.log("Submitted values:", values);
  //   const payload = {
  //     ...values,
  //     Mode: isEditMode ? "Update" : "Add",
  //     fullName: `${values.firstName} ${values.middleName} ${values.lastName}`.trim(),
  //     GroupID: values.GroupID ? values.GroupID : 1,
  //   }
  //   if (isEditMode) {
  //     payload.customerId = id;
  //   }
  //   console.log("Payload to be sent:", payload);
  //   saveCustomer(payload)
  //     .then(() => {
  //       toast.success("Customer added successfully! ");
  //       setIsSubmitting(false);
  //       window.history.back();
  //     })
  //     .catch((error) => {
  //       toast.error("Failed to add customer! ");
  //     });
  // }

  return (
    <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc" }}>
      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
          Customer Master
        </h5>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <Form>
              {/* Customer Type */}

              <div className="mb-4">
                <label className="fw-bold mb-2 d-block">Customer Type</label>
                <div className="d-flex gap-2">
                  <button

                    type="button"
                    className={`toggle-btn ${values.customerType === "Individual" ? "active" : ""}`}
                    onClick={() => setFieldValue("customerType", "Individual")}
                  >
                    Individual
                  </button>
                  <button
                    type="button"
                    className={`toggle-btn ${values.customerType === "Company" ? "active" : ""}`}
                    onClick={() => setFieldValue("customerType", "Company")}
                  >
                    Company
                  </button>
                </div>
              </div>

              <div className="row g-3">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Initial</label>
                  <Field as="select" name="initial" className="form-control custom-shadow">
                    <option value="selectedValue">Select</option>
                    <option value="Mr">Mr.</option>
                    <option value="Mrs">Mrs.</option>
                    <option value="Ms">Ms.</option>
                  </Field>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">First Name <span className="text-danger">*</span>
                  </label>
                  <Field name="firstName" className="form-control custom-shadow" />
                  <ErrorMessage name="firstName" component="div" className="text-danger" />

                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Middle Name</label>
                  <Field name="middleName" className="form-control custom-shadow" />
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Last Name</label>
                  <Field name="lastName" className="form-control custom-shadow" />
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Short Name</label>
                  <Field name="shortName" className="form-control custom-shadow" />
                </div>

                {/* Gender */}
                <div className="col-md-3 mb-3">
                  <label className="d-block form-label">Gender <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`toggle-btn ${values.gender == "Male" ? "active" : ""}`}
                      onClick={() => setFieldValue("gender", "Male")}
                    >
                      Male
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${values.gender == "Female" ? "active" : ""}`}
                      onClick={() => setFieldValue("gender", "Female")}
                    >
                      Female
                    </button>
                  </div>
                  <ErrorMessage name="gender" component="div" className="text-danger" />

                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Date of Birth <span className="text-danger">*</span>
                  </label>
                  <Field type="date" name="dob" className="form-control custom-shadow" />
                  <ErrorMessage name="dob" component="div" className="text-danger" />

                </div>


                {/* Group Head */}
                <div className="col-md-3 mb-3">
                  <label className="form-label d-block">Group Head <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`toggle-btn ${values.groupHead === "true" ? "active" : ""}`}
                      onClick={() => setFieldValue("groupHead", "true")}
                    >
                      Yes
                    </button>
                    <button

                      type="button"
                      className={`toggle-btn ${values.groupHead === "false" ? "active" : ""}`}
                      onClick={() => setFieldValue("groupHead", "false")}
                    >
                      No
                    </button>

                  </div>
                  <ErrorMessage name="groupHead" component="div" className="text-danger" />

                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Group Code <span className="text-danger">*</span></label>
                  <Field
                    as="select"
                    name="GroupID"
                    className="form-control custom-shadow"
                    value={values.GroupID}
                    onChange={(e) => {
                      const selectedId = e.target.value;

                      // ✅ Log selected GroupID
                      console.log("Selected GroupID:", selectedId);

                      // ✅ Optionally log the full selected group object
                      const selectedGroup = (groupsData?.data || []).find(g => String(g.GroupId) === selectedId);
                      console.log("Selected Group Object:", selectedGroup);

                      setFieldValue('GroupID', selectedId);

                      if (selectedId && selectedId !== '') {
                        setGroupIdForFetch(selectedId);
                      } else {
                        setGroupIdForFetch('');
                      }
                    }}
                  >
                    <option value="">Select Group Code</option>
                    {(groupsData?.data || []).map((g) => (
                      <option key={g.GroupId} value={g.GroupId}>
                        {g.GroupCode} - {g.GroupName}
                      </option>
                    ))}
                  </Field>


                  <ErrorMessage name="GroupID" component="div" className="text-danger" />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Marriage Date</label>
                  <Field type="date" name="marriageDate" className="form-control custom-shadow" />
                </div>

                {/* Is Dead */}
                <div className="col-md-3 mb-3">
                  <label className="d-block form-label">Is Dead?</label>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className={`toggle-btn ${values.isDead === "true" ? "active" : ""}`}
                      onClick={() => setFieldValue("isDead", "true")}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className={`toggle-btn ${values.isDead === "false" ? "active" : ""}`}
                      onClick={() => setFieldValue("isDead", "false")}
                    >
                      No
                    </button>
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Demise Date</label>
                  <Field type="date" name="demiseDate" className="form-control custom-shadow" />
                </div>

                {/* Contact Section */}
                <h6 className="text-secondary fw-bold mb-3 mt-5 bg-gray-100 rounded p-2">
                  Contact Information
                </h6>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Mobile 
                  </label>
                  <Field name="mobile" className="form-control custom-shadow" maxLength={10} onKeyDown={allowOnlyNumbers} />
                  <ErrorMessage name="mobile" component="div" className="text-danger" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Email 
                  </label>
                  <Field name="email" className="form-control custom-shadow" />
                  <ErrorMessage name="email" component="div" className="text-danger" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Pan 
                  </label>
                  <Field name="pan"
                    className="form-control custom-shadow text-uppercase"
                    maxLength={10}
                  />
                  <ErrorMessage name="pan" component="div" className="text-danger" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3 ">
                  <label className="form-label">Aadhar <span className="text-danger">*</span>
                  </label>
                  <Field name="aadhar" className="form-control custom-shadow" onKeyDown={allowOnlyNumbers} maxLength={12} />
                  <ErrorMessage name="aadhar" component="div" className="text-danger" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Address 1 <span className="text-danger">*</span>
                  </label>
                  <Field name="address1" className="form-control custom-shadow" />
                  <ErrorMessage name="address1" component="div" className="text-danger" />

                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Address 2</label>
                  <Field name="address2" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Address 3</label>
                  <Field name="address3" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Pin Code</label>
                  <Field name="pinCode" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">City</label>
                  <Field name="city" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">State</label>
                  <Field name="state" className="form-control custom-shadow" />
                </div>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-center gap-3 mt-5">
                <button type="submit" className="saveButton d-flex align-items-center px-4" disabled={isSubmitting}>
                  <LuSave className="me-2" />
                  {isSubmitting
                    ? (isEditMode ? "Updating..." : "Saving...")
                    : (isEditMode ? "Update" : "Add")}
                </button>
                <button type="button" className="backButton d-flex align-items-center px-4" onClick={() => window.history.back()}>
                  <GiCrossedBones className="me-2" />
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddCustomerMaster;
